import { render, staticRenderFns } from "./externalsystem.vue?vue&type=template&id=9c6b313e"
import script from "./externalsystem.vue?vue&type=script&lang=js"
export * from "./externalsystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports